import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../Components/filters/ActiveFilters";

import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  bayList,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "bay",
      label: "Bay",
      value: submittedData.bay
        ? bayList.find((b) => b.bay === submittedData.bay)?.bay || ""
        : "",
    },
  ];

  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
              bayList={bayList}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
